import { useApi } from '@/api/useApi.ts';
import { IAssetGroup } from '@/interfaces/storageForecasting/IAssetGroup.ts';
import type { IAssetGroupCreateRequest } from '@/interfaces/storageForecasting/IAssetGroupCreateRequest.ts';
import { IAssetGroupsResponse } from '@/interfaces/storageForecasting/IAssetGroupsResponse.ts';

const assetGroupsApiBase = useApi('deltaGpt');

async function getAllAssetGroups (): Promise<IAssetGroupsResponse> {
    const response = await assetGroupsApiBase.get<IAssetGroupsResponse>({
        endpoint: '/StorecastPageSettings',
    });
    return response.data;
}

async function createAssetGroup (request: IAssetGroupCreateRequest): Promise<IAssetGroup> {
    const response = await assetGroupsApiBase.post<IAssetGroupCreateRequest, IAssetGroup>({
        endpoint: '/StorecastPageSettings',
        payload: request,
    });
    return response.data;
}

async function updateAssetGroup (assetGroup: IAssetGroup): Promise<void> {
    await assetGroupsApiBase.put<IAssetGroup, void>({
        endpoint: '/StorecastPageSettings',
        payload: assetGroup,
    });
}

async function deleteAssetGroup (id: string): Promise<void> {
    await assetGroupsApiBase.delete<string, void>({
        endpoint: `/StorecastPageSettings/${id}`,
        payload: id,
    });
}

async function updateAssetGroupsOrdering (payload: { ordering: Array<string> }): Promise<void> {
    await assetGroupsApiBase.put<{ ordering: Array<string> }, void>({
        endpoint: '/StorecastPageSettings/ordering',
        payload,
    });
}

async function updateActiveAssetGroupTab (payload: { activeTabId: string }): Promise<void> {
    await assetGroupsApiBase.put<{ activeTabId: string }, void>({
        endpoint: '/StorecastPageSettings/activeTab',
        payload,
    });
}

export {
    getAllAssetGroups,
    createAssetGroup,
    updateAssetGroup,
    deleteAssetGroup,
    updateAssetGroupsOrdering,
    updateActiveAssetGroupTab,
};
